var md5 = require('js-md5');
var dateFormat = require('dateformat');
import moment from 'moment-timezone';

const BUILD = process.env.BUILT_FOR;



class Config {
  IS_HL7_VISIBLE = false;
  DM_CUSTOM_RANGE_JOURNEY = ['8'];
  HTN_CUSTOM_RANGE_JOURNEY = ['10', '13'];
  NO_CHANGE = '<NO CHANGE>';

  ROLE_USER = '0';
  ROLE_SUPER = '3';
  ROLE_MANAGER = '2';
  ROLE_OFFICE_ADMIN = '4';

  EMERGENCY_RESPONSE_TYPE = 2;

  DEFAULT_NOTIFICATION_TIME = '08:00:00';
  DEFAULT_NOTIFICATION_TIMEZONE = 'America/Los_Angeles';

  EXCLUDED_JIDS = [2, 7, 9, 15, 19];

  // spanish english mapping of journey ids
  SPANISH_ENGLISH_JIDS_MAP = {
    20: 1,
    21: 10,
    23: 8,
    26: 3,
    27: 4,
    28: 25,
  };

  getDayValue(day) {
    /**
     * Set it at  0 - 7.
     * Consider 3,4 to be 3,
     * consider 5,6 to be 5.
     * Does that help ?
     */
    var optionMap = {
      '7 days': 7,
      '7 días': 7,
      '5-7 days': 7,
      '5-6 days': 5,
      '5-6 días': 5,
      '3-4 days': 3,
      '3-4 días': 3,
      '2 days or less': 1,
      '2 o menos días': 1,
      '1-2 days': 1,
      'Have no prescriptions': 0,
      'Sin medicamentos recetados': 0,
    };

    return optionMap[day] || 0;
  }

  getAstControlValue(values) {
    /**
     * Set it at 1 - 4
     * 1 - Controlled/Intermittent
     * 2 - Partly Controlled / Mild Persistent
     * 3 - Uncontrolled / Moderate Persistent
     * 4 - Poorly Controlled / Severe Persistent
     */
    let optionMap = {
      0: 1,
      '1-2': 1,
      '3-6': 2,
      'Every day (not all day)': 3,
      'Every day (all day)': 4,
      1: 2,
      '2-3': 3,
      '4-7': 4,
      'Not at all': 1,
      Slightly: 1,
      Moderately: 2,
      'Very much': 3,
      Completely: 4,
      2: 3,
      '3-7': 3,
      '8-14': 4,
    };

    let optionOverrideByQuestion = {
      1: {
        'Over the past TWO weeks, how many nights did your child’s asthma keep your child from sleeping or wake him/her up?': 1,
      },
    };

    let astControl = values.map((value) => {
      let optionValue = optionMap[value.answer] || 0;

      if (optionOverrideByQuestion[value.answer]) {
        if (optionOverrideByQuestion[value.answer][value.question]) {
          optionValue = optionOverrideByQuestion[value.answer][value.question];
        }
      }

      return optionValue;
    });

    // return the max value
    return Math.max(...astControl);
  }

  getDepressionScore(values, type) {
    // this option map is also defined in surveySystemQuestion.php
    // make sure to update this in backend code if there are any changes
    const phqOptionMap = {
      'Not at all': 0,
      'Several days': 1,
      'More than half the days': 2,
      'Nearly every day': 3,
      'Ningún día': 0,
      'Varios días': 1,
      'Más de la mitad de los días': 2,
      'Casi todos los días': 3,
    };

    const fibserOptionMap = {
      'No impairment': 0,
      'Minimal or mild impairment': 1.5,
      'Moderate or marked impairment': 3.5,
      'Severe impairment': 5,
      'Unable to function': 6,
      'Sin limitación': 0,
      'Mínimas o leves limitaciones': 1.5,
      'Moderadas o bastantes limitaciones': 3.5,
      'Graves limitaciones': 5,
      'Incapaz de funcionar debido a los efectos': 6,
    };

    const optionMap = type === 'fibser' ? fibserOptionMap : phqOptionMap;

    const totalScore = values.reduce((acc, value) => {
      let optionValue = optionMap[value.answer] || 0;
      return acc + optionValue;
    }, 0);

    return totalScore;
  }

  getTimeZoneName() {
    try {
      //return `(${Intl.DateTimeFormat().resolvedOptions().timeZone})`;
      const str = /\((.*)\)/.exec(new Date().toString())[1];
      const matches = str.match(/\b(\w)/g); // ['J','S','O','N']
      const acronym = matches.join('');
      return `(${acronym})`;
    } catch (err) {
      return '(PST)';
    }
  }

  /**
   * Given a patient ref string, return an object that contains
   * the MRN, patient initials and doctor code
   * @param {string} patientRef
   * @return object
   */
  getPatientRefParts(patientRef) {
    const lastDashIndex = patientRef.lastIndexOf('-');
    const mrnWithPatientInitials = patientRef.substr(0, lastDashIndex);
    const doctorCode = patientRef.substr(lastDashIndex).slice(1);
    const patientInitials = mrnWithPatientInitials.substr(-2, 2);
    const mrn = mrnWithPatientInitials.slice(0, mrnWithPatientInitials.length - 2);

    return { mrn, patientInitials, doctorCode };
  }

  async validate(UID) {
    return await this.request('VALIDATE_UID', { UID });
  }

  async getAllReviewers(app_id, reviewer_type, startIdx = 0, queryAmount = 50) {
    return await this.request('get_all_reviewers', { app_id, reviewer_type, startIdx, queryAmount });
  }
  async getAllReviewStatus(app_id) {
    return await this.request('get_all_reviewers_status', { app_id });
  }

  async saveNote(PMHID, note) {
    return await this.request('save_review_notes', { PMHID, note });
  }

  async getNote(PMHID) {
    return await this.request('get_review_notes', { PMHID });
  }

  async getAppsForManagers() {
    return await this.request('get_apps_for_managers', {});
  }

  async insertReviewer(
    username,
    password,
    app_id,
    reviewer_type,
    group_code,
    initials,
    first_name,
    last_name,
    formMode,
    id,
    cluster_id
  ) {
    console.log('insertReviewer');
    console.log(
      username,
      password,
      app_id,
      reviewer_type,
      group_code,
      initials,
      first_name,
      last_name,
      formMode,
      id,
      cluster_id
    );

    if ((reviewer_type == this.ROLE_USER || reviewer_type === this.ROLE_OFFICE_ADMIN) && app_id == null) {
      throw new Error('App id must be given!');
    }
    if ((reviewer_type == this.ROLE_SUPER || reviewer_type == this.ROLE_MANAGER) && cluster_id == null) {
      throw new Error('Cluster should be given');
    }

    if (username == '' || password == '') {
      throw new Error('username or password is blank ');
    }

    const encPassword = password == this.NO_CHANGE ? this.NO_CHANGE : md5(password);
    return await this.request('admin_insert_reviewer', {
      username,
      password: encPassword,
      app_id,
      reviewer_type,
      group_code,
      initials,
      first_name,
      last_name,
      formMode,
      id,
      cluster_id,
    });
  }

  async deleteReviewer(id) {
    return await this.request('admin_delete_reviewer', { id });
  }

  getDateFormat(date, timepart = true, format = false) {
    if (date == null) {
      return '';
    }

    let dt = moment(date + '.000-07:00')
      .toDate()
      .getTime();
    if (typeof date === 'object') {
      dt = date.getTime();
    }
    if (isNaN(dt)) {
      return date;
    }
    let nDate = new Date(dt);

    if (format) {
      return dateFormat(nDate, format);
    }

    if (timepart) {
      return dateFormat(nDate, 'h:MM tt mm/dd/yy');
    } else {
      return dateFormat(nDate, 'mm/dd/yy');
    }
  }

  getMonthName(month) {
    const d = new Date();
    d.setMonth(month - 1);
    const monthName = d.toLocaleString('default', { month: 'long' });
    return monthName;
  }

  async addUpdateTemplate(app_id, view_title, title, body, link, id, category_id, formMode) {
    return await this.request('admin_add_template', {
      app_id,
      title,
      body,
      link,
      id,
      formMode,
      view_title,
      category_id,
    });
  }

  async addUpdateGroup(app_id, group_name, group_remark, divisions, id, formMode, active) {
    return await this.request('admin_add_group', { app_id, group_name, group_remark, id, formMode, divisions, active });
  }

  async setActiveGroup(app_id, active) {
    return await this.request('admin_set_active_group', { app_id, active });
  }

  async deleteTemplate(id) {
    return await this.request('admin_delete_template', { id });
  }

  async deleteGroup(id) {
    return await this.request('admin_delete_group', { id });
  }

  async getAutoAddDetails(app_id) {
    return await this.request('getAutoAddDetail', { app_id });
  }

  async getAllGroups(app_id) {
    return await this.request('admin_get_group', { app_id });
  }

  async getGroups(app_id, startIdx = 0, queryAmount = 50) {
    return await this.request('admin_get_group', { app_id, startIdx, queryAmount });
  }

  async getAllTemplates(app_id) {
    return await this.request('admin_get_template', { app_id });
  }

  async getTemplates(app_id, startIdx = 0, queryAmount = 50) {
    return await this.request('admin_get_template', { app_id, startIdx, queryAmount });
  }

  async getAllTemplatesCategory() {
    return await this.request('admin_get_template_category', {});
  }

  getHost() {
    if (BUILD == 'LIVE') {
      return 'https://cmdr-ops.com/';
    }
    if (BUILD == 'LOCAL') {
      return 'http://localhost:8888/';
    }
    if (BUILD == 'STAGE') {
      return 'https://stage.cmdr-ops.com/';
    }
    if (BUILD == 'DEV') {
      return 'https://dev.cmdr-ops.com/';
    }
  }

  async getPendingJourneys() {
    return await this.request('getPendingUserList', {});
  }

  /**
   *
   * @param {string} p_from_date  // 2020-08-23T16:06:46.337Z
   * @param {string} p_till_date
   * @param {number} startIdx
   * @param {number} queryAmount
   * @param {obj} filter
   * @param {obj} maxFilter
   */
  async getHl7Reviews({ p_from_date, p_till_date, startIdx = 0, queryAmount = 100, filter = {}, maxFilter = {} }) {
    let from_date = null;
    let till_date = null;

    if (p_from_date && p_till_date) {
      from_date = p_from_date.substring(0, 10);
      till_date = p_till_date.substring(0, 10);
    }

    return await this.request('getHl7Reviews', {
      from_date,
      till_date,
      startIdx,
      queryAmount,
      filter: JSON.stringify(filter),
      maxFilter: JSON.stringify(maxFilter),
    });
  }

  /**
   * @param {string} p_from_date
   * @param {string} p_till_date
   */
  async getAllHl7Reviews({ p_from_date, p_till_date, filter = {} }) {
    const from_date = p_from_date.substring(0, 10);
    const till_date = p_till_date.substring(0, 10);

    return await this.request('getAllHl7Reviews', { from_date, till_date, filter: JSON.stringify(filter) });
  }

  async getAllHl7JourneyNames({ p_from_date, p_till_date }) {
    const from_date = p_from_date.substring(0, 10);
    const till_date = p_till_date.substring(0, 10);

    return await this.request('getHl7ReviewJournies', { from_date, till_date });
  }

  async countHl7Reviews({ p_from_date, p_till_date, filter = {} }) {
    const from_date = p_from_date.substring(0, 10);
    const till_date = p_till_date.substring(0, 10);
    return await this.request('countHl7Reviews', { from_date, till_date, filter: JSON.stringify(filter) });
  }

  async setReviewedHl7(PMHID, YN) {
    return await this.request('setReviewedHl7', { PMHID, YN });
  }

  async setHl7Status(PMHID, status) {
    return await this.request('setHl7Status', { PMHID, status });
  }

  async getAllTCodesForPatient(patientId) {
    return await this.request('getAllTCodesForPatient', { patientId });
  }

  async getTcodeArchiveReason() {
    return await this.request('getTcodeArchiveReason', {});
  }

  async doExportFaxesToCSV() {
    return await this.request('doExportFaxesToCSV', {});
  }

  async requeFax(id) {
    return await this.request('reque_fax', { id: id });
  }

  async hideFax(id) {
    return await this.request('hideFax', { id: id });
  }

  async hashl7logmenu() {
    return await this.request('hashl7logmenu', {});
  }

  async getHl7Logs() {
    try {
      //no need any more
      //await this.request("REFRESH_HL7_LOGS",{});
    } catch (err) {}
    return await this.request('GET_HL7_LOGS', {});
  }

  async getAdminContent(key) {
    return await this.request('ADMIN_CONTENT', { CONTENT_KEY: key, MODE: 'GET' });
  }

  async getFaxLogs(page, pageSize, sortBy, direction) {
    return await this.request('getFaxLogs', { page: page, pageSize: pageSize, sort: sortBy, direction: direction });
  }

  async setAdminContent(key, content) {
    return await this.request('ADMIN_CONTENT', { CONTENT_KEY: key, MODE: 'SET', CONTENT: content });
  }

  async getFaxContent(PMHID, token = '') {
    if (token == '') {
      return await this.request('GET_FAX_CONTENT', { PMHID: PMHID });
      token = null;
    }
    return await this.request('GET_FAX_CONTENT', { PMHID: PMHID, token });
  }

  getAnswerFormated($iconName) {
    var $imagename = null;
    if ($iconName == '[R2C1]') {
      $imagename = 'very_happy.png';
    }
    if ($iconName == '[R1C1]') {
      $imagename = 'happy.png';
    }
    if ($iconName == '[R4C9]') {
      $imagename = 'ok.png';
    }
    if ($iconName == '[R6C2]') {
      $imagename = 'sad.png';
    }
    if ($iconName == '[R6C7]') {
      $imagename = 'very_sad.png';
    }
    if ($imagename == null) {
      return [$iconName, false];
    }
    return [this.getHost() + 'docportal_api/' + $imagename, true];
    //return <img height={40} widht={40} src={}/>;
  }

  async getDasReport(patient_ref, fax = false, sentInDate = null) {
    if (fax === true) {
      return await this.request('GET_DAS_REPORT', { patient_ref, fax: 'YES', sentInDate });
    } else {
      return await this.request('GET_DAS_REPORT', { patient_ref, sentInDate });
    }
  }

  async getOfficeDetail() {
    return await this.request('GET_OFFICE_DETAIL', {});
  }

  /**
   * Retrieve office detail by the doctor office id
   * @param {int} id
   */
  async getOfficeDetailById(id) {
    return await this.request('getOfficeDetailById', { id });
  }

  async getOfficeForAppId(app_id) {
    return await this.request('GET_OFFICES_BY_APP', { app_id });
  }

  async dd_getIndiDoctorByDoc(DOC_ID) {
    //GET_INDI_DOCTOR_BY_DOC
    return await this.request('DRILL_DOWN_REPORT', { SUB_ACTION: 'GET_INDI_DOCTOR_BY_DOC', DOC_ID });
  }

  async dd_getJourneyNames() {
    return await this.request('DRILL_DOWN_REPORT', { SUB_ACTION: 'GET_JOURNEY_NAMES' });
  }

  async dd_getPatientsForDoctor(DID) {
    //
    return await this.request('DRILL_DOWN_REPORT', { DID, SUB_ACTION: 'GET_PATIENT_BY_DOCTOR' });
  }

  async dd_getDoctorByApp(APP_CODE) {
    return await this.request('DRILL_DOWN_REPORT', { APP_CODE, SUB_ACTION: 'GET_DOCTORS_BY_APP' });
  }

  async dd_getAllTCodes(FROM_DATE, TILL_DATE) {
    return await this.request('DRILL_DOWN_REPORT', { SUB_ACTION: 'ALL_T_CODES', FROM_DATE, TILL_DATE });
  }

  async dd_getAllClubs() {
    return await this.request('DRILL_DOWN_REPORT', { SUB_ACTION: 'GET_APPS' });
  }

  async getSugarPressureDataForDevice(device_id) {
    return await this.request('GET_SUGAR_PRESSURE', { device_id });
  }

  async getChartDetail(tcode, filter) {
    return await this.request('GET_CHART_DATA', { T_CODE: tcode, FILTER: filter });
  }

  async requestResendAgain(PMHID, t_code) {
    return await this.request('SURVEY_REQUEST_RESEND', { PMHID, t_code });
  }

  async requestFaxAgain(PMHID, t_code) {
    return await this.request('FAX_SEND_AGAIN', { PMHID, t_code });
  }

  formatTCode(tcode) {
    if (!tcode) {
      return '';
    }
    return tcode.substring(0, 3) + ' ' + tcode.substring(3);
  }

  async clearAlert(t_code) {
    return await this.request('CLEAR_ALERT', { T_CODE: t_code });
  }

  async getAlertForDoctor(startIdx = 0, queryAmount = 50, tcodeOnly = 'N') {
    return await this.request('DOC_GET_ALERT', { startIdx, queryAmount, tcodeOnly });
  }

  async deleteTCODE(t_code, delete_reason) {
    return await this.request('DELELTE_T_CODE', { TCODE: t_code, deleteReason: delete_reason });
  }

  async addCluster(cluster_name, apps, formMode, id = null) {
    const output = await this.request('addCluster', { cluster_name, apps, formMode, id });
    if (output.result != 'SUCCESS') {
      throw new Error(output.error);
    }
  }

  async deleteCluster(id) {
    return await this.request('deleteCluster', { id });
  }

  async getAllClusters() {
    return await this.request('getAllClusters', {});
  }

  async getClusters(startIdx = 0, queryAmount = 50) {
    return await this.request('getAllClusters', { startIdx, queryAmount });
  }

  async sendMessageToTCode(t_code, title, message, link, category_id) {
    const response = await this.request('sendMessageToTCode', { t_code, title, message, link, category_id });

    if (response.SUCCESS === false) {
      const error = response.ERROR;
      if (typeof error == 'object') {
        const keys = Object.keys(error);
        if (keys.includes('invalid_player_ids')) {
          response.SUCCESS = true;
          console.log({ error: error });
        } else {
          const values = Object.values(error);
          response.ERROR = `${keys.join(', ')} ${values.join(', ')}`;
        }
      }
    }

    return response;
  }

  async getPatientJourneyDetailAdmin(t_code) {
    return await this.request('GET_PATIENT_JOURNEY_DETAIL_ADMIN', { t_code });
  }

  async getPatientJourneyDetail(t_code, startIdx = 0, queryAmount = 50) {
    return await this.request('GET_PATIENT_JOURNEY_DETAIL', { t_code, startIdx, queryAmount });
  }

  async getMessagesForAJourney(JID) {
    return await this.request('GET_JOURNEY_MESSAGES', { JID });
  }

  async getAllDoctors(archived, startIdx = 0, queryAmount = 50, sortOrder = null, sortDirection = null) {
    return await this.request('GET_ALL_DOCTORS', { archived, startIdx, queryAmount, sortOrder, sortDirection });
  }

  async getAllDoctorsArchived() {
    return await this.request('GET_ARCHIVED_DOCTORS', {});
  }
  /**
   *
   * @param {Number} JID
   * @param {String} patient_ref
   * @param {Date} DATE
   * @param {String} yob
   * @param {String} gender
   * @param {}
   */
  async addTCode(
    JID,
    patient_ref,
    DATE,
    yob,
    gender,
    custom_range = {
      low_emergency: 0,
      low_warning: 0,
      low_alert: 0,
      high_alert: 0,
      high_warning: 0,
      high_emergency: 0,
    },
    group_name,
    doctor_comment,
    selected_app,
    selected_office,
    emergency_msg_txt,
    bp_method,
    hl7_match_2,
    weight_required
  ) {
    return await this.request('SAVE_TID', {
      JID,
      patient_ref,
      DATE,
      yob,
      gender,
      custom_range,
      group_name,
      doctor_comment,
      selected_app,
      selected_office,
      emergency_msg_txt,
      bp_method,
      hl7_match_2,
      weight_required,
    });
  }


  async CHECK_EMP_ID_EXISTS(emp_id, app_code) {
    return await this.request('CHECK_EMP_ID_EXISTS', { emp_id, app_code });
  }


 

    async addTCodeAutoBP(
    JID,
    patient_ref,
    DATE,
    yob,
    gender,
   custom_range = {
        SYSTOLIC: {
            low_emergency: 85,
            low_warning: 95,
            low_alert: 90,
            high_warning: 140,
            high_alert: 145,
            high_emergency: 180
        },
        DIASTOLIC: {
            low_emergency: 50,
            low_warning: 65,
            low_alert: 60,
            high_warning: 90,
            high_alert: 95,
            high_emergency: 120
        }
    },
    group_name,
    doctor_comment,
    DID,
    clubID
  ) {
    return await this.request('SAVE_TID', {
      FROM_APP: 'YES',
      JID,
      patient_ref,
      DATE,
      yob,
      gender,
      custom_range,
      group_name,
      doctor_comment,
      DID,
      clubID,
      bp_method: 'bp_ai',
    });
  }

  async addTCodeAuto(
    JID,
    patient_ref,
    DATE,
    yob,
    gender,
    custom_range = {
      low_emergency: 0,
      low_warning: 0,
      low_alert: 0,
      high_alert: 0,
      high_warning: 0,
      high_emergency: 0,
    },
    group_name,
    doctor_comment,
    DID,
    clubID
  ) {
    return await this.request('SAVE_TID', {
      FROM_APP: 'YES',
      JID,
      patient_ref,
      DATE,
      yob,
      gender,
      custom_range,
      group_name,
      doctor_comment,
      DID,
      clubID,
    });
  }

  async getTCodeById(TID) {
    return await this.request('GET_TCODE_BY_ID', { TID });
  }

  /**
   * Update a t_code
   * @param {obj} TID
   */
  async updateTCode(tcodeObj) {
    return await this.request('updateTCode', tcodeObj);
  }

  /**
   * Updates a t_code guardrail
   * @param {int} TID
   * @param {obj} custom_range
   */
  async updateGuardRail(TID, custom_range = { low_warning: 0, low_alert: 0, high_alert: 0, high_warning: 0 }) {
    return await this.request('UPDATE_GUARD_RAIL', { TID, custom_range });
  }

  /**
   * Retrieves the emergency respone message with fallback
   * @param {int} JID
   * @param {int} DOC_ID
   * @param {int} TID
   */
  async getEmergencyResponse(JID, DOC_ID, TID) {
    const type_id = this.EMERGENCY_RESPONSE_TYPE;
    return await this.request('get_response_text', { JID, DOC_ID, TID, type_id, get_all: true });
  }

  /**
   * Updates the emergency response text by tcode
   * @param {int} TID
   * @param {string} response_text
   */
  async updateEmergencyResponseByTID(TID, response_text) {
    const type_id = this.EMERGENCY_RESPONSE_TYPE;
    return await this.request('save_tcode_response', { TID, type_id, response_text });
  }

  /**
   * Updates the emergency response text by office id
   * @param {int} JID
   * @param {int} DOC_ID
   * @param {string} response_text
   */
  async updateEmergencyResponseByOffice(JID, DOC_ID, response_text) {
    const type_id = this.EMERGENCY_RESPONSE_TYPE;
    return await this.request('save_office_response', { JID, DOC_ID, type_id, response_text });
  }

  async getJourneyForPatient(patient) {
    return await this.request('GET_PATIENT_JOURNEYS', { patient });
  }

  async getJourneysForDoctor(archived, startIdx = 0, queryAmount = 50, filter = {}, sort = {}) {
    if (archived == true) {
      return await this.request('GET_JOURNIES', {
        archived: 'YES',
        startIdx,
        queryAmount,
        filter: JSON.stringify(filter),
        sort: JSON.stringify(sort),
      });
    }
    return await this.request('GET_JOURNIES', {
      archived: 'NO',
      startIdx,
      queryAmount,
      filter: JSON.stringify(filter),
      sort: JSON.stringify(sort),
    });
  }

  async getSwitchableJourneys(JID) {
    return await this.request('GET_JOURNEY_switchable', { JID });
  }

  async switchJourney(from_jid, to_jid, t_code) {
    return await this.request('switch_journey', { t_code, from_jid, to_jid });
  }

  async getJourneyMaster(exclude_ids, columns = null) {
    return await this.request('GET_JOURNEY_MASTER', { exclude_ids, columns });
  }

  async logout() {
    this.IS_HL7_VISIBLE = false;
    return await this.request('LOGOUT', {});
  }

  async getADoctor(id) {
    return await this.request('GET_DOCTOR', { id });
  }

  async deleteDoctor(id) {
    return await this.request('DELETE_DOCTOR', { id });
  }

  async adminTestFax(username, fax) {
    var result = await this.request('ADMIN_TEST_FAX', { username, fax });
    return result;
  }

  async updateADoctor(
    id,
    username,
    password,
    club_id,
    remark,
    phone_number,
    fax,
    title,
    password_help,
    default_bp_method,
    allow_facial_scan,
    hl7_match_2_required,
    npi_format_required,
    weight_required_default,
    notification_time,
    notification_timezone
  ) {
    var obj = {
      id,
      username,
      club_id,
      remark,
      phone_number,
      fax,
      title,
      password_help,
      default_bp_method,
      allow_facial_scan,
      hl7_match_2_required,
      npi_format_required,
      weight_required_default,
      notification_time,
      notification_timezone,
    };
    if (password != 'NO_CHANGE_CHANGE') {
      obj.password = md5(password);
    } else {
      obj.password = password;
    }
    var result = await this.request('UPDATE_DOCTOR', obj);
    return result;
  }

  async saveADoctor(
    username,
    password,
    club_id,
    remark,
    phone_number,
    fax,
    title,
    password_help,
    default_bp_method,
    allow_facial_scan,
    hl7_match_2_required,
    npi_format_required,
    weight_required_default,
    notification_time,
    notification_timezone
  ) {
    var obj = {
      username,
      password: md5(password),
      club_id,
      remark,
      phone_number,
      fax,
      title,
      password_help,
      default_bp_method,
      allow_facial_scan,
      hl7_match_2_required,
      npi_format_required,
      weight_required_default,
      notification_time,
      notification_timezone,
    };
    var result = await this.request('SAVE_DOCTOR', obj);
    return result;
  }

  async getApps(no_active_office) {
    var result = await this.request('GET_APPS', { no_active_office });
    return result;
  }

  async getAppCodeJourney(app_code, jid) {
    var result = await this.request('GET_APP_CODE_JOURNEY', { APP_CODE: app_code, JID: jid });
    return result;
  }

  async getAppCodeJourneySurvey(app_code, jid) {
    var result = await this.request('GET_APP_CODE_JOURNEY_SURVEY', { APP_CODE: app_code, JID: jid });
    return result;
  }

  async saveAppCodeJourneySurvey(app_code_journey_id, survey_ids) {
    var result = await this.request('SAVE_APP_CODE_JOURNEY_SURVEY', {
      APP_CODE_JOURNEY_ID: app_code_journey_id,
      SURVEY_IDS: survey_ids,
    });
    return result;
  }

  async removeAppCodeJourneySurvey(app_code_journey_id, survey_ids) {
    var result = await this.request('REMOVE_APP_CODE_JOURNEY_SURVEY', {
      APP_CODE_JOURNEY_ID: app_code_journey_id,
      SURVEY_IDS: survey_ids,
    });
    return result;
  }

  async saveGuidanceResponse(app_code, jid, response_with_path, response_without_path) {
    var result = await this.request('SAVE_GUIDANCE_RESPONSE', {
      APP_CODE: app_code,
      JID: jid,
      GUIDANCE_RESPONSE_WITH_PATH: response_with_path,
      GUIDANCE_RESPONSE_WITHOUT_PATH: response_without_path,
    });
    return result;
  }

  async saveGuidancePaths(app_code_journey_id, guidances) {
    var result = await this.request('SAVE_GUIDANCE_PATHS', {
      APP_CODE_JOURNEY_ID: app_code_journey_id,
      GUIDANCE_PATHS: guidances,
    });
    return result;
  }

  async getAverageLastResponses(category, start_date, end_date, csv) {
    return await this.request('GET_AVERAGE_LAST_RESPONSES', { category, start_date, end_date, csv });
  }

  async getAverageAllResponses(category, start_date, end_date, csv, journeyStartDate) {
    return await this.request('GET_AVERAGE_ALL_RESPONSES', { category, start_date, end_date, csv, journeyStartDate });
  }

  async doATest() {
    const resulte = await fetch('http://173.230.140.65/docportal_api/bootstrap.php', {
      method: 'POST',
      credentials: 'include',
      mode: 'no-cors',
      body: JSON.stringify({ ACTION: 'getAlertsForAll', DID: 11 }),
    });
    const resultObje = await resulte.json();
    console.log(resultObje);
  }

  async request(ACTION, body) {
    if (BUILD == 'LIVE') {
      this.SERVER = '/docportal_api/bootstrap.php';
    }
    if (BUILD == 'LOCAL') {
      this.SERVER = 'http://localhost:8888/docportal_api/bootstrap.php';
    }
    if (BUILD == 'STAGE') {
      this.SERVER = '/docportal_api/bootstrap.php';
    }
    if (BUILD == 'DEV') {
      this.SERVER = '/docportal_api/bootstrap.php';
    }
    body.ACTION = ACTION;
    var resp = await fetch(this.SERVER, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(body),
    });
    try {
      if (resp.headers.get('content-length') == '0') {
        throw new Error('Your session has timed out please login again.');
      }

      const val = await resp.json();
      if (val.error_code == 401) {
        localStorage.setItem('UID', '');
        localStorage.setItem('app_code', '');
        localStorage.setItem('username', '');
        localStorage.setItem('cluster_id', '');
        window.location.reload();
      }

      return val;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  getBuild() {
    return BUILD;
  }
}

module.exports = new Config();
